import React, {useEffect, useRef, useState} from "react";
import ReviewSnippet from "@Pages/reviewWidget/components/ReviewSnippet";
import ScrollableWithFade from "@Containers/components/ScrollableWithFade";

function ReviewsList({reviews, activeReview, setActiveReview}) {
    return (
        <ScrollableWithFade classNames="gb--review-container gb--review-list" numberOfItemsDisplayed={4.5}>
            {reviews?.map((review) => {
                let isActive = false;
                if (review?.ticketId) {
                    isActive = (review.ticketId + review.direction) == (activeReview.ticketId + activeReview.direction)
                } else {
                    isActive = review.dateTime == activeReview.dateTime
                }
                return (
                    <ReviewSnippet
                        isActive={isActive}
                        review={review}
                        setActiveReview={() => setActiveReview(review)}
                        key={review?.ticketId ? review.ticketId + review.direction : review.dateTime}
                    />
                )
            })}
        </ScrollableWithFade>
    );
}

export default ReviewsList;